import { useRouter } from 'fitify-ui-onboarding/src/hooks/useRouter'
import { useMemo } from 'react'

import { Funnel } from 'types/state'

export const useFunnel = () => {
  const router = useRouter()

  return useMemo<Funnel | undefined>(() => {
    const path = router.resolvedPathname

    return Object.values(Funnel).find((funnelValue) =>
      path.startsWith(`/${funnelValue}`)
    )
  }, [router.resolvedPathname])
}
